module.exports = __webpack_public_path__ + "media/images/honey/250g-40a7e56fe6f318764c23589cab5e21a4.png";